import { render, staticRenderFns } from "./BulkSampleEditDialog.vue?vue&type=template&id=2715183d"
import script from "./BulkSampleEditDialog.vue?vue&type=script&lang=js"
export * from "./BulkSampleEditDialog.vue?vue&type=script&lang=js"
import style0 from "./BulkSampleEditDialog.vue?vue&type=style&index=0&id=2715183d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports